import { layoutPadding } from '@/core/constants/class-names'
import { ROUTES } from '@/core/constants/routes'
import { Footer } from '@/core/ui/footer'
import { CustomerHeader } from '@/core/ui/header'
import { Link } from '@/i18n/navigation'
import { getTranslations } from 'next-intl/server'
import Image from 'next/image'

export const Error404 = async () => {
  const t = await getTranslations()

  return (
    <>
      <CustomerHeader sticky shadow showNav className={layoutPadding} />
      <div className='my-4 flex min-h-screen flex-col gap-2 px-8 lg:px-24'>
        <main className='mb-6 flex flex-col gap-8'>
          <h1 className='text-3xl font-medium'>{t('notFound.title')}</h1>
          <div className='border-grey-20 flex flex-col items-center justify-center gap-3 rounded border px-2 py-8 md:px-16'>
            <div className='relative h-80 min-h-40 w-full'>
              <Image
                src='/images/errors/404.svg'
                fill
                alt='404 | Page not found'
              />
            </div>
            <p className=''>{t('notFound.msg')}</p>
            <Link
              href={ROUTES.home}
              className='mb-16 flex-1 text-lg font-medium underline transition-opacity hover:opacity-85'
            >
              {t('links.goHome')}
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    </>
  )
}
